import React from "react";
import { Link } from "react-router-dom";
import "../styles/Home.css";

const Privacy = () => {
  return (
    <div className="gybtc-container">
      <header className="gybtc-header scrolled">
        <div className="gybtc-header-content">
          <div className="gybtc-logo-container">
            <img
              src="/gybtc-logo.png"
              alt="Grow Your BTC Logo"
              className="gybtc-logo"
            />
          </div>

          <nav className="gybtc-nav">
            <Link to="/" className="gybtc-nav-link">Home</Link>
            <Link to="/faq" className="gybtc-nav-link">FAQ</Link>
            <Link to="/terms" className="gybtc-nav-link">Terms</Link>
            <Link to="/disclaimer" className="gybtc-nav-link">Disclaimer</Link>
            <a href="/book" className="gybtc-btn-nav-cta">Book 1:1</a>
          </nav>
        </div>
      </header>

      <section className="gybtc-about" style={{ paddingTop: "140px", minHeight: "100vh" }}>
        <div className="gybtc-section-header">
          <h1 className="gybtc-section-title">Privacy Policy</h1>
        </div>

        <div className="gybtc-about-grid" style={{ gridTemplateColumns: "1fr" }}>
          <div className="gybtc-about-card">
            <p className="gybtc-about-card-text">
              Grow Your BTC respects your privacy. This policy explains what information
              may be collected when you use this website, join the newsletter, contact us,
              or book a session.
            </p>

            <h3 className="gybtc-about-card-title">What we may collect</h3>
            <p className="gybtc-about-card-text">
              We may collect your name, email address, and any information you choose to
              provide when subscribing, contacting us, or booking a service.
            </p>

            <h3 className="gybtc-about-card-title">How we use your information</h3>
            <p className="gybtc-about-card-text">
              Your information may be used to respond to enquiries, deliver newsletters,
              provide purchased services, improve the website experience, and share relevant
              updates about Grow Your BTC.
            </p>

            <h3 className="gybtc-about-card-title">Payments</h3>
            <p className="gybtc-about-card-text">
              Payment providers may process billing details directly. Grow Your BTC does not
              store sensitive card or payment credentials unless explicitly stated.
            </p>

            <h3 className="gybtc-about-card-title">Email communications</h3>
            <p className="gybtc-about-card-text">
              If you subscribe to the newsletter or contact us, we may email you about
              Bitcoin education, updates, offers, or service information. You can unsubscribe
              at any time.
            </p>

            <h3 className="gybtc-about-card-title">Cookies and analytics</h3>
            <p className="gybtc-about-card-text">
              This website may use basic cookies, analytics tools, or similar technologies to
              understand traffic and improve performance.
            </p>

            <h3 className="gybtc-about-card-title">Data protection</h3>
            <p className="gybtc-about-card-text">
              Reasonable steps are taken to protect your information, but no online system is
              completely risk-free.
            </p>

            <h3 className="gybtc-about-card-title">Third-party services</h3>
            <p className="gybtc-about-card-text">
              This website may link to third-party platforms such as payment processors,
              booking tools, apps, or email services. Their privacy policies apply separately.
            </p>

            <h3 className="gybtc-about-card-title">Your rights</h3>
            <p className="gybtc-about-card-text">
              You may request access, correction, or deletion of your personal information by
              contacting us.
            </p>

            <h3 className="gybtc-about-card-title">Contact</h3>
            <p className="gybtc-about-card-text">
              For privacy-related questions, contact: <strong>jared@growyourbtc.com</strong>
            </p>
          </div>
        </div>
      </section>

      <footer id="footer" className="gybtc-footer">
        <div className="gybtc-footer-content">
          <p className="gybtc-footer-text">
            © 2025 Grow Your BTC • <Link to="/privacy">Privacy Policy</Link> •{" "}
            <Link to="/terms">Terms</Link> • <Link to="/disclaimer">Disclaimer</Link> •{" "}
            <Link to="/faq">FAQ</Link>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Privacy;
